<!-- Scheduling Conflict Modal -->
<div class="conflict-modal-backdrop" *ngIf="showConflictModal" (click)="showConflictModal = false">
  <div class="conflict-modal" (click)="$event.stopPropagation()">
    <div class="conflict-modal-header">
      <button type="button" class="conflict-close-btn" (click)="showConflictModal = false">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12 4L4 12M4 4L12 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
    <div class="conflict-modal-body">
      <div class="conflict-icon-wrapper">
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path d="M11 7V11M11 15H11.01M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#f59e0b" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <p class="conflict-title">{{ 'Scheduling Conflict' | translate }}</p>
      <p class="conflict-message">{{ 'Some of the selected products or categories are already scheduled for a discount in the same date or time period.' | translate }}</p>
      <button type="button" class="conflict-ok-btn" (click)="showConflictModal = false">{{ 'Got it' | translate }}</button>
    </div>
  </div>
</div>

<div class="discount-page">
  <form (ngSubmit)="onSubmit(f.value)" #f="ngForm">

    <!-- Back Button -->
    <div class="backButton" (click)="builderService.navigateBack()">
      <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
    </div>

    <!-- Page Header -->
    <div class="page-header">
      <div class="header-left">
        <p class="page-title">{{ (editPage ? 'Edit Discount' : 'Create Discount') | translate }}</p>
        <p class="page-subtitle">{{ 'Set up a new time-based sale or promotion.' | translate }}</p>
      </div>
      <div class="header-right">
        <button type="button" class="cancel-btn" (click)="builderService.navigateBack()">
          <span>{{ 'Cancel' | translate }}</span>
        </button>
        <button type="submit" class="submit-btn" [disabled]="saving">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span>{{ (editPage ? 'Update Discount' : 'Create Discount') | translate }}</span>
        </button>
      </div>
    </div>

    <!-- =============================== -->
    <!-- Discount Info Card              -->
    <!-- =============================== -->
    <div class="section-card">
      <div class="card-header">
        <h3>{{ 'Discount Info' | translate }}</h3>
      </div>
      <div class="card-body">

        <!-- Sale Name + Discount Criteria -->
        <div class="fields-row">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Sale Name' | translate }}</label>
            </div>
            <div class="genie-input">
              <input
                type="text"
                [placeholder]="'Summer Sale' | translate"
                name="discountName"
                [(ngModel)]="discountName"
                #discountInput="ngModel"
                required
              />
            </div>
            <div *ngIf="invalidationMessage" class="field-error">{{ invalidationMessage }}</div>
            <div *ngIf="discountInput.invalid && discountInput.touched" class="field-error">{{ 'Sale name is required.' | translate }}</div>
          </div>

          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Discount Criteria' | translate }}</label>
            </div>
            <div class="genie-input">
              <select
                [(ngModel)]="selectedCriteria"
                name="selectedCriteria"
                #criteriaSelectInput="ngModel"
                required
              >
                <option value="" disabled>{{ 'Select Criteria' | translate }}</option>
                <option *ngFor="let criteria of discountCriteriaMap | keyvalue" [value]="criteria.key">
                  {{ criteria.value | translate}}
                </option>
              </select>
            </div>
            <div *ngIf="criteriaSelectInput.invalid && criteriaSelectInput.touched" class="field-error">{{ 'Please select a discount criteria.' | translate }}</div>
          </div>
        </div>

        <!-- Discount Amount -->
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Discount Amount' | translate }}</label>
          </div>
          <div class="input-with-suffix">
            <div class="genie-input">
              <input
                type="number"
                [placeholder]="'Discount Amount' | translate"
                min="1"
                name="discountPercentage"
                [(ngModel)]="discountPercentage"
                #discountPctInput="ngModel"
                required
              />
            </div>
            <span class="input-suffix">%</span>
          </div>
          <p class="field-hint">{{ 'Enter the percentage discount to apply during this promotion.' | translate }}</p>
          <div *ngIf="discountPctInput.invalid && discountPctInput.touched" class="field-error">{{ 'Discount Percentage is required.' | translate }}</div>
        </div>

      </div>
    </div>

    <!-- =============================== -->
    <!-- Products Table (conditional)    -->
    <!-- =============================== -->
    <div class="section-card table-card" *ngIf="showProducts()">
      <div class="card-header card-header-with-action">
        <h3>{{ 'Select Specific Product(s)' | translate }}</h3>
        <div class="search-input-wrapper">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <input #query (keyup)="filterProducts(query.value)" type="text" [placeholder]="'Search' | translate" />
        </div>
      </div>

      <div class="genie-table-wrapper">
        <table class="genie-table">
          <thead>
            <tr>
              <th>{{ 'Image' | translate }}</th>
              <th>{{ 'Name' | translate }}</th>
              <th>{{ 'Stock' | translate }}</th>
              <th>{{ 'Price' | translate }}</th>
              <th>{{ 'Date' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of productsDataSource.data">
              <td class="image-cell">
                <mat-checkbox [checked]="isChecked(product, 'product')" class="products-checkbox" (change)="onProductSelect(product, $event)"></mat-checkbox>
                <div class="productImgContainer">
                  <img loading="lazy" [src]="product.imageUrl | primaryImage" class="image" [alt]="'Product' | translate" />
                </div>
              </td>
              <td>{{ product.productName }}</td>
              <td>{{ (getStock(product) > 0 ? product.productStock : ('Out of Stock' | translate)) }}</td>
              <td>{{ product.salePrice ? product.regularPrice + ' / ' + product.salePrice : product.regularPrice }}</td>
              <td>{{ product.date }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Products Pagination -->
      <div class="genie-pagination">
        <div class="pagination-info">
          <span class="current-page">{{ pageIndex + 1 }}</span>
          <span class="page-separator">{{ 'of' | translate }}</span>
          <span class="total-pages">{{ filteredProducts.length > 0 ? (filteredProducts.length / pageSize | number:'1.0-0') : 1 }}</span>
        </div>
        <div class="pagination-controls">
          <button type="button" class="page-btn" [disabled]="pageIndex === 0" (click)="onPageChange({ pageIndex: pageIndex - 1, pageSize: pageSize, length: filteredProducts.length, previousPageIndex: pageIndex })">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
          <button type="button" class="page-btn" [disabled]="(pageIndex + 1) * pageSize >= filteredProducts.length" (click)="onPageChange({ pageIndex: pageIndex + 1, pageSize: pageSize, length: filteredProducts.length, previousPageIndex: pageIndex })">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" /></svg>
          </button>
        </div>
      </div>

      <!-- Selected Products -->
      <div *ngIf="selectedProducts.length > 0" class="selected-section">
        <h4 class="selected-title">{{ 'Selected Products' | translate }}</h4>
        <div class="genie-table-wrapper">
          <table class="genie-table">
            <thead>
              <tr>
                <th>{{ 'Select' | translate }}</th>
                <th>{{ 'Image' | translate }}</th>
                <th>{{ 'Name' | translate }}</th>
                <th>{{ 'Stock' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of selectedProductsDataSource.data">
                <td>
                  <mat-checkbox [checked]="isChecked(product, 'product')" (change)="onProductSelect(product, $event)"></mat-checkbox>
                </td>
                <td class="image-cell">
                  <div class="productImgContainer">
                    <img loading="lazy" [src]="product.imageUrl | primaryImage" class="image" [alt]="'Product' | translate" />
                  </div>
                </td>
                <td>{{ product.productName }}</td>
                <td>{{ (getStock(product) > 0 ? product.productStock : ('Out of Stock' | translate)) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- =============================== -->
    <!-- Categories Table (conditional)  -->
    <!-- =============================== -->
    <div class="section-card table-card" *ngIf="showCategories()">
      <div class="card-header card-header-with-action">
        <h3>{{ 'Select Specific Categories' | translate }}</h3>
        <div class="search-input-wrapper">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <input #queryC (keyup)="filterCategories(queryC.value)" type="text" [placeholder]="'Search' | translate" />
        </div>
      </div>

      <div class="category-list">
        <div class="category-row" *ngFor="let category of categoriesDataSource.data">
          <mat-checkbox [checked]="isChecked(category, 'category')" (change)="onCategorySelect(category, $event)"></mat-checkbox>
          <img loading="lazy" [src]="category.image || 'assets/images/empty-image.png'" class="cat-image" alt="" />
          <span class="cat-name">{{ category.name }}</span>
        </div>
      </div>

      <!-- Selected Categories -->
      <div *ngIf="selectedCategories.length > 0" class="selected-section">
        <h4 class="selected-title">{{ 'Selected Categories' | translate }}</h4>
        <div class="category-list selected-cats">
          <div class="category-row" *ngFor="let cat of selectedCategories">
            <mat-checkbox [checked]="isChecked(cat, 'category')" (change)="onCategorySelect(cat, $event)"></mat-checkbox>
            <img loading="lazy" [src]="cat.image || 'assets/images/empty-image.png'" class="cat-image" alt="" />
            <span class="cat-name">{{ cat.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- =============================== -->
    <!-- Discount Schedule Card          -->
    <!-- =============================== -->
    <div class="section-card">
      <div class="card-header">
        <h3>{{ 'Discount Schedule' | translate }}</h3>
      </div>
      <div class="card-body">

        <!-- Dates Row -->
        <div class="fields-row two-cols">

          <!-- Start Date -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Start Date' | translate }}</label>
            </div>
            <div class="picker-wrapper">
              <svg class="picker-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66667 1.16675V2.91675M9.33333 1.16675V2.91675M1.75 5.25008H12.25M2.33333 2.91675H11.6667C11.9889 2.91675 12.25 3.17784 12.25 3.50008V11.6667C12.25 11.9889 11.9889 12.2501 11.6667 12.2501H2.33333C2.01117 12.2501 1.75 11.9889 1.75 11.6667V3.50008C1.75 3.17784 2.01117 2.91675 2.33333 2.91675Z" stroke="#ADADAD" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <input
                class="picker-input"
                [matDatepicker]="pickerFrom"
                [(ngModel)]="dateFrom"
                name="dateFrom"
                [placeholder]="'mm/dd/yyyy' | translate"
                readonly
                required
              />
              <mat-datepicker-toggle [for]="pickerFrom" class="picker-toggle"></mat-datepicker-toggle>
              <mat-datepicker #pickerFrom></mat-datepicker>
            </div>
          </div>

          <!-- End Date -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'End Date' | translate }}</label>
            </div>
            <div class="picker-wrapper">
              <svg class="picker-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.66667 1.16675V2.91675M9.33333 1.16675V2.91675M1.75 5.25008H12.25M2.33333 2.91675H11.6667C11.9889 2.91675 12.25 3.17784 12.25 3.50008V11.6667C12.25 11.9889 11.9889 12.2501 11.6667 12.2501H2.33333C2.01117 12.2501 1.75 11.9889 1.75 11.6667V3.50008C1.75 3.17784 2.01117 2.91675 2.33333 2.91675Z" stroke="#ADADAD" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <input
                class="picker-input"
                [matDatepicker]="pickerTo"
                [(ngModel)]="dateTo"
                name="dateTo"
                [placeholder]="'mm/dd/yyyy' | translate"
                readonly
                required
              />
              <mat-datepicker-toggle [for]="pickerTo" class="picker-toggle"></mat-datepicker-toggle>
              <mat-datepicker #pickerTo></mat-datepicker>
            </div>
          </div>

        </div>

        <!-- Times Row -->
        <div class="fields-row two-cols">

          <!-- Start Time -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Start Time' | translate }}</label>
            </div>
            <div class="picker-wrapper time-picker-wrapper" [matMenuTriggerFor]="timeMenuFrom">
              <svg class="picker-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 12.8334C10.2217 12.8334 12.8333 10.2217 12.8333 7.00008C12.8333 3.77842 10.2217 1.16675 7 1.16675C3.77834 1.16675 1.16667 3.77842 1.16667 7.00008C1.16667 10.2217 3.77834 12.8334 7 12.8334Z" stroke="#ADADAD" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 3.50008V7.00008L9.33333 8.16675" stroke="#ADADAD" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="picker-display">{{ selectedTimeFrom || ('8:00 am' | translate) }}</span>
              <svg class="picker-chevron" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M8.29924 3.72949L5.58258 6.44616C5.26174 6.76699 4.73924 6.76699 4.41841 6.44616L1.70174 3.72949" stroke="#ADADAD" stroke-width="0.625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <input type="text" name="timeFrom" [(ngModel)]="selectedTimeFrom" style="display:none" />
            </div>
            <mat-menu #timeMenuFrom="matMenu" class="time-picker-panel" overlapTrigger="false">
              <div class="time-menu-content" (click)="$event.stopPropagation()">
                <div class="time-grid">
                  <button type="button" *ngFor="let hour of [1,2,3,4,5,6,7,8,9,10,11,12]" class="hour-btn" (click)="setTime(hour, 0, timeMenuFrom, 'from')">
                    {{ hour | number:'2.0' }}:00
                  </button>
                </div>
                <div class="am-pm-row">
                  <button type="button" class="period-btn" [class.active]="!isPMFrom" (click)="togglePeriod(timeMenuFrom, 'from')">{{ 'AM' | translate }}</button>
                  <button type="button" class="period-btn" [class.active]="isPMFrom" (click)="togglePeriod(timeMenuFrom, 'from')">{{ 'PM' | translate }}</button>
                </div>
              </div>
            </mat-menu>
          </div>

          <!-- End Time -->
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'End Time' | translate }}</label>
            </div>
            <div class="picker-wrapper time-picker-wrapper" [matMenuTriggerFor]="timeMenuTo">
              <svg class="picker-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 12.8334C10.2217 12.8334 12.8333 10.2217 12.8333 7.00008C12.8333 3.77842 10.2217 1.16675 7 1.16675C3.77834 1.16675 1.16667 3.77842 1.16667 7.00008C1.16667 10.2217 3.77834 12.8334 7 12.8334Z" stroke="#ADADAD" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7 3.50008V7.00008L9.33333 8.16675" stroke="#ADADAD" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="picker-display">{{ selectedTimeTo || ('8:00 pm' | translate) }}</span>
              <svg class="picker-chevron" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M8.29924 3.72949L5.58258 6.44616C5.26174 6.76699 4.73924 6.76699 4.41841 6.44616L1.70174 3.72949" stroke="#ADADAD" stroke-width="0.625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <input type="text" name="timeTo" [(ngModel)]="selectedTimeTo" style="display:none" />
            </div>
            <mat-menu #timeMenuTo="matMenu" class="time-picker-panel" overlapTrigger="false">
              <div class="time-menu-content" (click)="$event.stopPropagation()">
                <div class="time-grid">
                  <button type="button" *ngFor="let hour of [1,2,3,4,5,6,7,8,9,10,11,12]" class="hour-btn" (click)="setTime(hour, 0, timeMenuTo, 'to')">
                    {{ hour | number:'2.0' }}:00
                  </button>
                </div>
                <div class="am-pm-row">
                  <button type="button" class="period-btn" [class.active]="!isPMTo" (click)="togglePeriod(timeMenuTo, 'to')">{{ 'AM' | translate }}</button>
                  <button type="button" class="period-btn" [class.active]="isPMTo" (click)="togglePeriod(timeMenuTo, 'to')">{{ 'PM' | translate }}</button>
                </div>
              </div>
            </mat-menu>
          </div>

        </div>

      </div>
    </div>

  </form>
</div>
